import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import Styles from './Section.module.scss'

export const Section = ({
  title,
  description,
  children,
  actions,
}: {
  title: React.ReactNode
  description?: string
  children: React.ReactNode
  actions?: React.ReactNode
}) => {
  return (
    <div className={Styles.section}>
      <div className={Styles.header}>
        <div className={Styles.titleAndActions}>
          <Heading level={5}>{title}</Heading>
          {actions && <div className={Styles.actions}>{actions}</div>}
        </div>
        {description && <Text variant="placeholder">{description}</Text>}
      </div>
      {children}
    </div>
  )
}
